import { SellerAccountModel } from "../models/SellerAccountModel";
import { SellerModel } from "../models/SellerModel";
import apiService from "./apiService";

const authService = {
    /**
     * 
     * @param username 
     * @param password 
     * @param reCaptchaToken 
     * @returns "InvalidReCaptchaToken", "Error","Success"
     */
    login: async (username: string, password: string, reCaptchaToken: string) => {
        return await apiService.post("/auth/sellerLogin", { username: username, password: password, reCaptchaToken: reCaptchaToken });
    },
    logout: async () => {
        return await apiService.post("/auth/logout", null);
    },
    /**
     * 
     * @param username 
     * @param password 
     * @param firstname 
     * @param lastname 
     * @param storeName 
     * @param timezone 
     * @param reCaptchaToken 
     * @returns "InvalidReCaptchaToken", "UsernameExist", "IncompleteFields", "InvalidUsernameFormat", "PasswordTooShort", "Success" and "Error"
     */
    register: async (username: string, password: string, firstname: string, lastname: string, storeName: string, timezone: string, reCaptchaToken: string) => {
        return await apiService.post("/auth/SellerRegister", {
            username: username,
            password: password,
            firstName: firstname,
            lastName: lastname,
            storeName: storeName,
            timezone: timezone,
            reCaptchaToken: reCaptchaToken
        });
    },
    /**
     * 
     * @param email 
     * @param reCaptchaToken 
     * @returns "InvalidReCaptchaToken", "TooFrequent", "EmailFailed", "Success" and "Error".
     */
    forgotPassword: async (email: string, reCaptchaToken: string) => {
        return await apiService.post("/auth/ForgotPassword", { username: email, reCaptchaToken: reCaptchaToken });
    },
    /**
     * 
     * @param token 
     * @returns "Valid", "Invalid", "Expired"
     */
    validateForgotPasswordToken: async (token: string) => {

        return await apiService.get(`/Auth/ForgotPassword/${token}`);
    },
    /**
     * 
     * @param token 
     * @param newPassword 
     * @returns "InvalidToken", "TokenExpired", "PasswordTooShort", "Success" and "Error"
     */
    resetPassword: async (token: string, newPassword: string) => {
        return await apiService.put(`/Auth/ResetPassword/`, { token: token, password: newPassword });
    },
    getSessionProfile: async() => {
        return await apiService.get("/Auth/SessionProfile");
    },
    /**
     * fake check session function to simulate session checking
     * @returns 
     */
    checkSession: async () => {
        try {
            // In real life, you'd do: return await apiService.get("/auth/checkSession");
            // For now, we simulate a delay and return fake data
            await new Promise((resolve) => setTimeout(resolve, 500)); // simulate latency

            const isLoggedIn = false; // change to false to simulate not logged in

            if (isLoggedIn) {
                return {
                    loginState: "Success",
                    sellerAccount: new SellerAccountModel({
                        sellerAccountID: 4,
                        sellerID: 4,
                        username: "mwang@healthpi.com.au",
                        firstname: "Minwen",
                        lastname: "Wang",
                        contactNumber: "+1234567890",
                        timezone: "Australia/Sydney",
                        emailVerified: false,
                    }),
                    seller: new SellerModel({
                        sellerId: 4,
                        sellerName: "MW Store2",
                        sellerDescription: "test2ww2",
                        logo: "4_4uq2sns41ix9.jpg",
                        addressLine1: "123 Main St111112s",
                        addressLine2: "Suite 4B2s",
                        city: "Springfield2s2",
                        state: "IL3342s",
                        postcode: "627021",
                        country: "Uganda",
                        email: "dara@healthpi.com.au",
                        contactNumber: "621726273262743",
                        shippingPolicy: "",
                        returnPolicy: "",
                        paymentTerms: "",
                        paymentMethods: [],
                    })
                };
            }
            else {
                return { loginState: 'LoginExpired', result: null };
            }
        } catch (error: any) {
            return { loginState: "Error", result: null };
        }
    }
}

export default authService